import { render, staticRenderFns } from "./assignment-update-modal.vue?vue&type=template&id=6d1dbcd2&scoped=true"
import script from "./assignment-update-modal.vue?vue&type=script&lang=js"
export * from "./assignment-update-modal.vue?vue&type=script&lang=js"
import style0 from "./assignment-update-modal.vue?vue&type=style&index=0&id=6d1dbcd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1dbcd2",
  null
  
)

export default component.exports